import { gql } from '@apollo/client';
import { NEW_ACCIDENT } from '../../fragments/accident';

export const FETCH_ACCIDENTS = gql`
  query FetchAccidents($input: FilterAccidentList!) {
    accidents(input: $input) {
      accidents { ...NewAccident }
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }
  ${NEW_ACCIDENT}
`;

export const GET_ACCIDENT_BY_ID = gql`
  query getAccidentById($id: ID!) {
    accident(id: $id) { ...NewAccident }
  }
  ${NEW_ACCIDENT}
`;

// Warm-up de caché para el detalle de OT/campaña e informes: resuelve N
// Accidents en UNA query servidor (backend `accidentsByIds`, tenant-scoped,
// máx 200 ids, ids ajenos/inexistentes omitidos EN SILENCIO y orden de
// salida NO garantizado — irrelevante: solo interesa poblar la caché
// normalizada). Usa EXACTAMENTE el fragment NewAccident (el mismo de
// GET_ACCIDENT_BY_ID) para que los `client.query(GET_ACCIDENT_BY_ID,
// cache-first)` per-row den hit vía el redirect `Query.accident →
// toReference` de policies.ts. Igual que Communication (y a diferencia de
// Action, caveat isBasic), el type Accident NO tiene ningún @ResolveField
// en el backend (verificado 2026-07-21) y el select del batch
// (ACCIDENT_LIST_SELECT) cubre el type Accident COMPLETO — se puede pedir
// el fragment entero sin excepciones.
export const GET_ACCIDENTS_BY_IDS = gql`
  query AccidentsByIds($ids: [ID!]!) {
    accidentsByIds(ids: $ids) { ...NewAccident }
  }
  ${NEW_ACCIDENT}
`;

export const GET_CONDITIONS_DRIVING_BY_ID = gql`
  query GetConditionsDrivingById($id: ID!) {
    conditionsDriving(id: $id) {
      id
      name
    }
  }
`;

export const GET_IMAGE_BY_ID = gql`
  query GetImageById($id: ID!) {
    image(id: $id) {
      id
      name
      creatingDate
      cloudinaryPublicId
      storageKey
      storageProvider
      # Migración Hetzner: el backend deja de firmar URLs; expone la URL pública
      # del objeto (null si legacy). El frontend reconstruye la fetch URL con el
      # SDK Cloudinary (ver utils/cloudinary.ts).
      publicUrl
      # T56 fix: Campos para sketch completo
      sketchSvg
      sketchFabricJson
      orderIDs
    }
  }
`;

export const GET_LUMINOSITY_BY_ID = gql`
  query GetLuminosityById($id: ID!) {
    luminosity(id: $id) {
      id
      name
    }
  }
`;

export const GET_MEDIUM_KNOWLEDGE_BY_ID = gql`
  query GetMediumKnowledgeById($id: ID!) {
    mediumKnowledge(id: $id) {
      id
      name
    }
  }
`;

export const GET_SURFACE_CONDITION_BY_ID = gql`
  query GetSurfaceConditionById($id: ID!) {
    surfaceCondition(id: $id) {
      id
      name
    }
  }
`;

export const GET_SURVEILLANCE_BODY_BY_ID = gql`
  query GetSurveillanceBodyById($id: ID!) {
    surveillanceBody(id: $id) {
      id
      name
    }
  }
`;

export const GET_WEATHER_BY_ID = gql`
  query GetWeatherById($id: ID!) {
    weather(id: $id) {
      id
      name
    }
  }
`;
